module.exports = __webpack_public_path__ + "img/robot1lb1.6f8f6f68.png";